import api from './index'
import attentionApi, { type AttentionKey, type AttentionResponse } from './attention'

export interface AdminNavigationBadges {
  pending_coach_applications: number
  pending_referee_applications: number
  new_kit_orders: number
  pending_championship_moderation: number
  pending_device_reports: number
  new_stadiums: number
  unread_support_conversations: number
}

const adminNavigationApi = {
  async getBadges(): Promise<AdminNavigationBadges> {
    const response = await api.get('/admin/navigation/badges')
    return response.data
  },
  getAttention(): Promise<AttentionResponse> {
    return attentionApi.get()
  },
  markAttentionSeen(key: AttentionKey): Promise<void> {
    return attentionApi.markSeen(key)
  }
}

export default adminNavigationApi
